import React, { useEffect, useState } from "react";
import axios from "axios";
import { Car, TrendingUp, Clock, Award, Flame } from "lucide-react";
import { Card } from "@/components/ui/card";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function DriverTodayStats() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      const r = await axios.get(`${API}/driver/today-stats`);
      setStats(r.data);
    } catch { /* silent */ }
    setLoading(false);
  };
  useEffect(() => { load(); const iv = setInterval(load, 15000); return () => clearInterval(iv); }, []);

  if (loading || !stats) return null;
  const maxVal = Math.max(1, ...stats.hourly_series.map(h => h.value));

  return (
    <Card className="p-5 bg-gradient-to-br from-green-500/10 via-primary/10 to-purple-500/10 border-green-500/40" data-testid="driver-today-stats">
      <div className="flex items-center gap-2 mb-3">
        <div className="w-9 h-9 rounded-xl bg-green-600 text-white flex items-center justify-center">
          <TrendingUp className="w-5 h-5" />
        </div>
        <div>
          <div className="font-bold text-lg leading-tight">Ganhos de hoje</div>
          <div className="text-[11px] text-muted-foreground">Atualiza a cada 15s</div>
        </div>
      </div>
      <div className="grid grid-cols-4 gap-2 text-center">
        <StatBox label="Corridas" value={stats.rides_completed} icon={<Car className="w-3.5 h-3.5" />} testid="stat-rides" />
        <StatBox label="Bruto" value={`R$ ${stats.gross.toFixed(2)}`} testid="stat-gross" />
        <StatBox label="Líquido" value={`R$ ${stats.net_payout.toFixed(2)}`} highlight testid="stat-net" />
        <StatBox label="Online" value={`${stats.hours_online.toFixed(1)}h`} icon={<Clock className="w-3.5 h-3.5" />} testid="stat-online" />
      </div>
      {stats.best_hour !== null && stats.best_hour_value > 0 && (
        <div className="mt-3 flex items-center gap-2 text-xs text-muted-foreground" data-testid="driver-best-hour">
          <Award className="w-3.5 h-3.5 text-amber-500" />
          Melhor hora hoje: <strong className="text-foreground">{String(stats.best_hour).padStart(2, "0")}h</strong> — R$ {stats.best_hour_value.toFixed(2)}
        </div>
      )}
      {/* mini hourly chart */}
      <div className="mt-3">
        <div className="flex items-end h-16 gap-[2px]">
          {stats.hourly_series.map((h) => (
            <div
              key={h.hour}
              className="flex-1 rounded-t bg-gradient-to-t from-green-500 to-emerald-300 opacity-80 hover:opacity-100 transition-opacity"
              style={{ height: `${(h.value / maxVal) * 100}%`, minHeight: h.value > 0 ? 3 : 1 }}
              title={`${String(h.hour).padStart(2, "0")}h — R$ ${h.value.toFixed(2)}`}
            />
          ))}
        </div>
        <div className="flex justify-between text-[9px] text-muted-foreground mt-1">
          <span>00h</span><span>06h</span><span>12h</span><span>18h</span><span>23h</span>
        </div>
      </div>
    </Card>
  );
}

function StatBox({ label, value, highlight, icon, testid }) {
  return (
    <div className={`p-2 rounded-lg ${highlight ? "bg-primary text-primary-foreground" : "bg-background/60"}`} data-testid={testid}>
      <div className={`text-[10px] uppercase tracking-wide flex items-center justify-center gap-1 ${highlight ? "opacity-80" : "text-muted-foreground"}`}>
        {icon} {label}
      </div>
      <div className="text-sm font-bold mt-0.5">{value}</div>
    </div>
  );
}
